import { ModalComponent } from "cruzo/ui-components/modal";
import type { UiLang } from "site/services/i18n";
import { appScope } from "site/api";

export type LessonTranslateModalResult = {
  targetLangs: UiLang[];
};

let pending: {
  resolve: (result: LessonTranslateModalResult) => void;
  reject: () => void;
} | null = null;

export function requestLessonTranslateTargets(): Promise<LessonTranslateModalResult> {
  if (pending) {
    return Promise.reject(new Error("lesson translate modal already open"));
  }
  return new Promise((resolve, reject) => {
    pending = { resolve, reject };
    ModalComponent.attach("lessonTranslateModal", appScope.id);
  });
}

export function completeLessonTranslateModal(targetLangs: UiLang[]): void {
  pending?.resolve({ targetLangs });
  pending = null;
}

export function cancelLessonTranslateModal(): void {
  pending?.reject(new Error("cancelled"));
  pending = null;
}
